export interface FormulaDetailData {
  id: number;
  title: string;
  subtitle: string;
  content: string;
}

export const mockFormulas: FormulaDetailData[] = [
  {
    id: 1,
    title: "CÔNG THỨC BACCARAT VIP 1",
    subtitle: "PHƯƠNG PHÁP TỰ CHƠI BACCARAT",
    content: `## THẾ CẦU 1
BỘ CÔNG THỨC BACCARAT
ÁP DỤNG TRONG SẢN PHẨM SEXY BẮT THẾ CẦU CHUẨN 99% DÀNH CHO ANH EM TỰ CHƠI, RẢNH LÚC NÀO CHƠI LÚC ĐÓ
**CẦU NGHIÊNG CÁI**
+ Thế cầu này anh em vào bàn nhìn bảng cầu phụ để lắm hướng kết quả sau biểu đồ bảng cầu phụ đang đi bệt từ 3 - 4 tay về điều thì anh em bắt bệt
**CẦU NGHIÊNG CON**
+ Thế cầu này anh em nhìn bảng cầu phụ để lắm hướng kết quả sau biểu đồ bảng cầu phụ đang đi bệt từ 3 - 4 tay về con thì anh em bắt bệt con
**CẦU NGHIÊNG CON 1 - 1**
Thế cầu này thường sẽ đi 1 -1 nhưng nghiêng về mà con nhiều
Cũng tương tự thế cầu trên nhưng nếu về hoà thì bắt bệt con
## THẾ CẦU 2
**CẦU 1 CON 2 CÁI**
+ Thế cầu bắt ngược lại thế cầu của kết quả tay trước
**CẦU LỪA 123**
+ Khi gặp thế cầu này mà đoạn cuối của thế cầu đổ kết quả về con thì bắt bệt con + về thì bắt bệt
**CẦU 12**
+ Đánh chạm về kết quả tay trước là cái thì tay sau đánh x2 vào con (và ngược lại)
## THẾ CẦU 3
**TAY HOÀ 1 - 2**
Đoạn này kết quả chỉ về 2 lần liên tiếp lần thứ 3 anh em sẽ bắt hoà nhé
**CẦU HOÀ LỪA**
+ Mạnh trên vếu có để hoà và bệt từ 3 4 tay, tay sau sẽ bẻ và bắt hoà tiếp
**CU LOẠN**
+ Thường hay xuất hiện ở bàn Baccarat C09, thế cầu này đánh theo bảng cầu phụ và chỉ ăn 3 4 tay rồi đổi bàn`
  },
  {
    id: 2,
    title: "CÔNG THỨC BACCARAT VIP 2",
    subtitle: "PHƯƠNG PHÁP TỰ CHƠI BACCARAT",
    content: `![LV2](/assets/lv2.png)
# CÁCH BẮT CẦU 2-1-2
ĐANG THẾ CẦU CHƯA CHẠM CHÂN 4 NÊN ĐỂ Ý SẼ VỀ 2-1-2 VÀ THẾ CẦU 22 ANH EM CỨ THEO BÁM BỆT THẾ CẦU TAM GIÁC ĐI XÚN KHI ĐANG NHƯ VẬY KHẢNH VỀ CẦU 1-1 KHÁ CAO VÀ THƯỜNG SẼ CÓ BỆT 1-1 TRƯỜNG HỢP 2 LÀ SẼ CÓ 4-3-2 NHƯ BẢN BẢNG
# CÁCH BẮT CẦU 3-2-3
NHỮNG BÀN NÀY THÌ THẾ THẾ CẦU MÌNH CHỈ NÓ SẼ VỀ 3-2-3 XONG RỒI VỀ 2-2
CHÚ Ý THEO LỆNH NHƯ NÀY CÓ THỂ GẤP LÊN VÀ SAU 3-2-3 LÀ CÓ THỂ MÌNH NGƯNG SANG BÀN MỚI
# CÁCH BẮT CẦU 1-1 BỆT CHÂN
CU NÀY TỶ LỆ ĐANG VỀ 1-1 TAY THỨ 4 THEO ĐẾN CHẠM 2 LẦN SẼ CHUYỂN ĐỔI QUA HƯỚNG KHÁC NHỮNG THẾ CẦU NHƯ NÀY SẼ ĐI 1 LẦN NỮA BẮT và CẦU VÀI TAY MÌNH LẠI ĐỔI BÀN ĐẤU Ý Ý CAU 2-1-2 THEO DÕI 2 3 TAY SAU CÓ THỂ VỀ 123 NÊN ANH EM CHƠI CÓ LÃI CÓ THỂ NGƯNG.`
  },
  {
    id: 3,
    title: "CÔNG THỨC BACCARAT VIP 3",
    subtitle: "Chiến thuật đặc biệt cho người chơi có kinh nghiệm",
    content: `![LV3-1](/assets/lv3-1.png)
![LV3-2](/assets/lv3-2.png)`
  },
  {
    id: 4,
    title: "CÔNG THỨC BACCARAT VIP 4",
    subtitle: "THỦ THUẬT LV4 PHƯƠNG PHÁP TỰ CHƠI BACCARAT",
    content: `# 5 AI NÊN DÙNG CHIẾN LƯỢC 1-3-2-6?
Người muốn nhân lợi nhuận nhanh nhưng không chịu rủi ro cao
Người có kỷ luật, không phá chiến lược khi thắng/thua
Người chơi theo cầu bệt, cầu 1-1, không đánh ngẫu nhiên
Bạn muốn học cách áp dụng 1-3-2-6 chi tiết hơn? Inbox ngay để nhận hướng dẫn VIP!

# 1 | CHIẾN LƯỢC ĐI VỐN 50/50 LÀ GÌ?
Chiến lược 50/50 = Chia vốn thành 50 đơn vị nhỏ & chỉ sát 2% mỗi bên
Ông Mục tiêu: Kiểm soát tài khoản, hạn chế rủi ro và tối đa hóa lợi nhuận dài hạn
Nguyên tắc quan trọng:
Không cân tay – Chỉ số 2% tài khoản mỗi phần
– Kiểm soát lại
Thua → giảm 50% cấp độ để bảo đảm vốn
Kết quả: 50/50 giúp bạn duy trì cuộc chơi lâu dài, tránh all-in và bảo vệ tài khoản khỏi cháy!

# 2 CÁCH ÁP DỤNG CHIẾN LƯỢC 50/50
Nguyên tắc.
+ Giả sử bạn có 10 — Chia thành 50 đơn vị = 200k/đơn vị
Ván đầu — Cược 2% tài khoản (200k)
Nếu thắng → Giữ nguyên 200k ê ê Giảm
xuống – giảm 50% còn 100k, không thấp
Ván
Ví dụ chi tiết:
trượt cấp số (VND)
trượt cấp số (VND)
Kết quả Tổng lãi đỗ
200k
X Thua
-200k
2
100k
X Thua
-300k
100k
<
Thắng
-200k
200k
Thắng
- Tháng
+200k
) Kết luận: Dù thua 2 chuyến đầu, bạn vẫn có lãi kiểm soát rút gọn!

# 3 | ƯU ĐIỂM & NHƯỢC ĐIỂM CỦA CHIẾN LƯỢC 50/50
ƯU ĐIỂM:
Bảo vệ tài khoản, không nhanh lợi nhuận như Martingale v Duy trì lợi nhuận ổn định, không cần chuỗi thắng dài Không cần vốn quá lớn, phù hợp với mọi người chơi
X NHƯỢC ĐIỂM
A. Lợi nhuận tăng chậm hơn so với Martingale hoặc Paroli
A Cần & kỷ luật cao
» KẾT LUẬN: Chiến lược 50/50 là phương pháp đi vốn an toàn, giúp người chơi duy trì cuộc chơi dài hạn!

# MẸO ÁP DỤNG 50/50 HIỆU QUẢẢNG NHẤT
1 Chỉ số 2% tài khoản mỗi kỳ – Không all-in
Ô ô. Duy trì vốn lâu dài, không bị cháy vì vài lần thua liên tiếp!
| 2 | Không tăng số lượng khi thu hồi – Giảm 50% để bảo toàn vốn
Đây Không gỡ lỗi, chỉ tập trung vào quản lý rủi ro!
| 3 | Chơi theo cầu đẹp – Không đánh ngẫu nhiên!
. Sử dụng yêu cầu nhận dạng TOOL để chọn thời điểm vào lệnh!
+ KẾT LUẬN: 50/50 chỉ thực sự hiệu quả khi đi kèm với phân tích cầu chính xác & kỷ luật chặt chẽ.

# 5 | AI NÊN DÙNG CHIẾN LƯỢC 50/50?
Người muốn chơi dài hạn mà không bị cháy tài khoản
Vì Người không thích rủi ro cao nhưng vẫn mong muốn lợi nhuận ổn định
Người có kỷ luật, không phá vỡ chiến lược khi thắng/thua
Bạn muốn học áp dụng cách sử dụng 50/50 chi tiết hơn? Inbox ngay để nhận hướng dẫn VIP!`
  },
  {
    id: 5,
    title: "CÔNG THỨC BACCARAT VIP 5",
    subtitle: "BỘ CÔNG THỨC BACCARAT DÀNH CHO TẤT CẢ CÁC ANH EM KHÔNG CÓ THỜI GIAN THEO NHÓM HOẶC MẤT PHƯƠNG HƯỚNG CHƠI",
    content: `![LV5](/assets/lv5.png)
# CÁCH 1: HỆ SỐ CÔNG THỨC CẤP SỐ NHÂN
ĐÁNH CẦU ĐÁNH CẦU BỆT VỀ CÁI ĐÁNH CÁI VỀ CON SẼ ĐÁNH CON
X1 10K X220K X3 60K X4 240K X5 1200K
ĂN THÌ ĐÁNH X1 THUA MÌNH ĐÁNH LÊN X1 10K X220K X3 60K X4 240K X5 1200K

# CÁCH 2: CHỌN BÀN CẦU 2.2
CÁCH ĐÁNH KHI CẦU ĐANG 123 THÌ MÌNH BẮT ĐẦU VÀO TIỀN BẺ CẦU VÀO TIỀN
VI DỤ NHƯ CẦU ĐANG ĐI 1 CON 2 CÁI 1 CON THÌ SẼ BẮT ĐẦU VÀO TIỀN TAY CON
X1 200K X2400K X3 1200K THẮNG THUA QUAY VỀ X1 200K

# CÁCH 3: CẦU 1-1 2
CHỌN BÀN CẦU BỆT 6-8 TAY 2
SẼ XUẤT HIỆN CẦU 1-12
THẾ CẦU NÀY MỌI NGƯỜI ĐI ĐỀU TAY NẾU CẦU CHẠY 1-1 5 TAY SẼ BẮT ĐẦU BẺ GẤP THÉP VỐN

# CÁCH 4: CẦU 1-1 2
CẦU BỆT
HAY BỆT CẦU Ở NHỮNG BÀN CẦU 1-1
CÁCH NHẬN BIẾT CẦU 1-1 SẼ ĐI TẦM 5 TAY TRỞ LÊN
KHI XUẤT HIỆN CẦU THẾ MÌNH SẼ TIẾN HÀNH BỆNH XUỐNG CẦU BỆT ĐÁNH ĐỀU TAY BỆT ĐẾN TẦM 8 TAY THÌ MÌNH SẼ TIẾN HÀNH BẺ GẤP THÉP Chú ÝC TẤT CẢ ANH EM THẮNG LỚN CÔNG CÔNG THỨC NÀY`
  },
  {
    id: 6,
    title: "CÔNG THỨC BACCARAT VIP 6",
    subtitle: "Chiến lược dài hạn và bền vững",
    content: `![LV6](/assets/lv6.png)
# CÔNG THỨC 1
KHI GẶP 2 VÁN CON RA 9 NÚT LIÊN TỤC, HOẶC CÁI RA 9 NÚT LIÊN TỤC 2 VÁN THÌ BÁM BỆT. KHẢ NĂNG RA BỆNH TRÊN 80%

# CÔNG THỨC 2
KHI GẶP DẠNG CẦU 4-2-1 THÌ ANH EM BÁM CẦU 1-1 TẦM 6-7 TAY, TỶ LỆ RA CẦU 1:1 NÀY TRÊN 70%

# CÔNG THỨC 3
KHI GẶP CON ĐÔI CÁI ĐÔI 2 VÁN LIÊN TỤC THÌ VÁN THỨ 3 VÀ THỨ 4 ANH EM LÓT HOÀ. TỶ LỆ RA HOÀ TRÊN 80%

# CÔNG THỨC 4
KHI GẶP CẦU 1-1 ĐƯỢC TẦM 5-7 TAY, NẾU XUẤT HIỆN RA KẾT QUẢ 9 NÚT THÌ BẺ CẦU, TỶ LỆ WIN TRÊN 90%`
  },
  {
    id: 7,
    title: "CÔNG THỨC BACCARAT VIP 7",
    subtitle: "Bí mật từ các chuyên gia quốc tế",
    content: `![LV7](/assets/lv7.png)
# BỘ CÔNG THỨC BACCARAT DÀNH CHO TẤT CẢ CÁC ANH EM KHÔNG CÓ THỜI GIAN THEO NHÓM HOẶC MẤT PHƯƠNG HƯỚNG CHƠI

# CÁCH 1
HỆ SỐ CÔNG THỨC CẤP SỐ NHÂN ĐÁNH CẦU ĐÁNH CẦU BỆT VỀ CÁI ĐÁNH CÁI VỀ CON SẼ ĐÁNH CON X1 10K X220K X3 60K X4 240K X5 1200K ĂN THÌ ĐÁNH X1 THUA MÌNH ĐÁNH LÊN X1 10K X220K X3 60K X4 240K X5 1200K

# CÁCH 2: CẦU 123
CHỌN BÀN CẦU 2.2 CÁCH ĐÁNH KHI CẦU ĐANG 123 THÌ MÌNH BẮT ĐẦU VÀO TIỀN BẺ CẦU VÀO TIỀN VI DỤ NHƯ CẦU ĐANG ĐI 1 CON 2 CÁI 1 CON THÌ SẼ BẮT ĐẦU VÀO TIỀN TAY CON X1 200K X2400K X3 1200K THẮNG THUA QUAY VỀ X1 200K

# CÁCH 3: CẦU 1-1
CHỌN BÀN CẦU BỆT 6-8 TAY SẼ XUẤT HIỆN CẦU 1-1 THẾ CẦU NÀY MỌI NGƯỜI ĐI ĐỀU TAY NẾU CẦU CHẠY 1-1 5 TAY SẼ BẮT ĐẦU BẺ GẤP THÉP VỐN

# CÁCH 4: CẦU BỆT
HAY BỆT CẦU Ở NHỮNG BÀN CẦU 1-1 CÁCH NHẬN BIẾT CẦU 1-1 SẼ ĐI TẦM 5 TAY TRỞ LÊN KHI XUẤT HIỆN CẦU THẾ MÌNH SẼ TIẾNH BẺ XUỐNG CẦU BỆT ĐÁNH ĐỀU TAY BỆT ĐẾN TẦM 8 TAY THÌ MÌNH SẼ TIẾN HÀNH BẺ GẤP THÉP Chú Ý TẤT CẢ ANH EM THẮNG LỚN CÔNG THỨC NÀY`
  },
  {
    id: 8,
    title: "CÔNG THỨC BACCARAT VIP 8",
    subtitle: "Kỹ thuật cao cấp cho người chơi chuyên nghiệp",
    content: `![LV8](/assets/lv8.png)`
  },
  {
    id: 9,
    title: "CÔNG THỨC BACCARAT VIP 9",
    subtitle: "Bí quyết tối thượng từ các bậc thầy",
    content: `# THẾ CẦU 1
BỘ CÔNG THỨC BACARAT ÁP DỤNG TRONG SẢN PHẨM SEXY BẮT THẾ CẦU CHUẨN 99% DÀNH CHO ANH EM TỰ CHƠI, DẢNH NÚC NÀO CHƠI NÚC ĐÓ
- CẦU NGHIÊNG CÁI
+ THẾ CẦU NÀY ANH EM VÀO BÀN NHÌN BẢNG CẦU PHỤ ĐỂ LẮM HƯỚNG KẾT QUẢ SAU BIỂU ĐỒ BẢNG CẦU PHỤ ĐANG ĐI BỆT TỪ 3 - 4 TAY VỀ ĐIỀU THÌ ANH EM BẮT BỆT
- CẦU NGHIÊNG CON
+ THẾ CẦU NÀY ANH EMO B NHÌN BẢNG CẦU PHỤ ĐỂ LẮM HƯỚNG KẾT QUẢ SAU BIỂU ĐỒ BẢNG CẦU PHỤ ĐANG ĐI BỆT TỪ 3 - 4 TAY VỀ CON THÌ ANH EM BẮT BỆT CON
- CẦU NGHIÊNG CON 1 - 1
THẾ CẦU NÀY THƯỜNG SẼ ĐI 1 -1 NHƯNG NGHIÊNG VỀ MÀ CON NHIỀU
CŨNG TƯƠNG TỰ THẾ CẦU TRÊN NHƯNG NẾU VỀ HOÀ THÌ BẮT BỆT CON
-THẾ CẦU 2
CẦU 1 CON 2 CÁI
+ THẾ CẦU BẮT NGƯỢC LẠI THẾ CẦU CỦA KẾT QUA TAY TRƯỚC
- CẦU LỪA 123
+ KHI GẶP THẾ CẦU NÀY MÀ ĐOẠN CUỐI CỦA THẾ CẦU ĐỔ KẾT QUẢ VỀ CON THÌ BẮT BỆT CON + VỀ THÌ BẮT BỆT
- CẦU 12
+ ĐÁNH CHẠM VỀ KẾT QUẢ CA TRƯỚC LÀ CÁI THÌ TAY SAU ĐÁNH X2 VÀO CON ( VÀ NGƯỢC LẠI)
THẾ CẦU 3 :
- TAY HOÀ 1 - 2
ĐOẠN NÀY KẾT QUẢ CHỈ VỀ 2 LẦN LIÊN TIẾP LẦN THỨ 3 ANH EM SẼ BẮT HOÀ NHÉ
- CẦU HOÀ LỪA
+ MạnhA TRÊN VẾU CÓ ĐỂ HOÀ VÀ BỆT TỪ 3 4 TAY, TAY SAU SẼ Bẻ và BẮT HOÀ TIẾP
- CU LOẠN
+ THƯỜNG HAY XUẤT HIỆN Ở BÀN BACARAT C09, THẾ CẦU NÀY ĐÁNH THEO BẢNG CẦU PHỤ VÀ CHỈ ĂN 3 4 TAY RỒI ĐỔI BÀN`
  }
];

export const getFormulaById = (id: number): FormulaDetailData | undefined => {
  return mockFormulas.find(formula => formula.id === id);
};
